import React from 'react'

export const WithdrawCheckedSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="268"
      height="268"
      viewBox="0 0 268 268"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_979:347500)">
        <circle cx="132" cy="134" r="101" fill="#20265C" />
      </g>
      <g filter="url(#filter1_i_979:347500)">
        <path
          d="M132 187.333C161.455 187.333 185.333 163.455 185.333 133.999C185.333 104.544 161.455 80.666 132 80.666C102.545 80.666 78.6665 104.544 78.6665 133.999C78.6665 163.455 102.545 187.333 132 187.333Z"
          fill="white"
        />
        <path
          d="M110.667 136.666L126.667 152.666L153.333 120.666"
          stroke="#3E4685"
          strokeWidth="6"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <circle
        cx="134"
        cy="134"
        r="133"
        stroke="white"
        strokeWidth="2"
      />
      <circle cx="233" cy="36" r="18" fill="white" />
      <circle cx="33" cy="227" r="18" fill="white" />
      <defs>
        <filter
          id="filter0_b_979:347500"
          x="-119"
          y="-117"
          width="502"
          height="502"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feGaussianBlur
            in="BackgroundImage"
            stdDeviation="75"
          />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_979:347500"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_979:347500"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_i_979:347500"
          x="78.6665"
          y="80.666"
          width="106.667"
          height="112.666"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.49 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_979:347500"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default WithdrawCheckedSvg
